/* Better Together CT – scroll reveal for bt-* sections */
(function () {
  var els = document.querySelectorAll('.bt-reveal');
  if (!els.length) return;
  document.documentElement.classList.add('bt-js');
  // Safety net: never leave content hidden
  setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (el, i) {
    el.style.transitionDelay = ((i % 4) * 80) + 'ms';
    io.observe(el);
  });
  document.querySelectorAll('.bt-pc form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button');
      if (btn) { btn.textContent = 'Adding…'; }
    });
  });
})();
